import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorStateService } from '../../../services/error-state.service';

/**
 * ErrorOverlayComponent - Overlay globale per errori di connessione
 * 
 * Mostra un overlay fullscreen quando l'applicazione è in stato di errore
 * dopo multipli tentativi di connessione falliti.
 * Offre un pulsante "Riprova" per tentare nuovamente.
 */
@Component({
  selector: 'app-error-overlay',
  templateUrl: './error-overlay.component.html',
  styleUrls: ['./error-overlay.component.scss']
})
export class ErrorOverlayComponent implements OnInit, OnDestroy {
  
  isVisible = false;
  errorMessage = '';
  errorType: 'network' | 'server' | 'timeout' | 'unknown' = 'unknown';
  isRetrying = false;
  
  private subscriptions: Subscription[] = [];

  constructor(private errorStateService: ErrorStateService) {}

  ngOnInit(): void {
    // Sottoscrivi allo stato di errore
    this.subscriptions.push(
      this.errorStateService.isInErrorState$.subscribe(isError => {
        this.isVisible = isError;
        if (!isError) {
          this.isRetrying = false;
        }
      })
    );
    
    // Sottoscrivi al messaggio di errore
    this.subscriptions.push(
      this.errorStateService.errorMessage$.subscribe(message => {
        this.errorMessage = message;
      })
    );
    
    // Sottoscrivi al tipo di errore
    this.subscriptions.push(
      this.errorStateService.errorType$.subscribe(type => {
        this.errorType = type;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Gestisce il click sul pulsante Riprova
   */
  onRetry(): void {
    this.isRetrying = true;
    this.errorStateService.requestRetry();
    
    // Ricarica la pagina per resettare lo stato dell'app
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  /**
   * Ottiene l'icona appropriata per il tipo di errore
   */
  getErrorIcon(): string {
    switch (this.errorType) {
      case 'network':
        return 'cloud-offline-outline';
      case 'server':
        return 'server-outline';
      case 'timeout':
        return 'time-outline';
      default:
        return 'warning-outline';
    }
  }

  /**
   * Ottiene il titolo appropriato per il tipo di errore
   */
  getErrorTitle(): string {
    switch (this.errorType) {
      case 'network':
        return 'Connection Error';
      case 'server':
        return 'Server Unavailable';
      case 'timeout':
        return 'Request Timeout';
      default:
        return 'Something Went Wrong';
    }
  }
}
